export default {
  meta: {
    title: '门店列表配置'
  }
};
